export const getMetadataFieldValue = fieldValue => {
  if (!fieldValue) return fieldValue;
  const {
    fieldDataIdentifier,
    propertyName,
    propertyToken,
    value
  } = fieldValue;
  if (Array.isArray(value)) return value;
  return value || propertyName || propertyToken || fieldDataIdentifier && fieldDataIdentifier.dataKey;
};